import React, { useEffect, useState } from "react";
import Header from "./Header";
import '../styles/MultiStepForm3.scss'
import goaImg from '../assets/Domestic/goa.webp';
import pondiImg from '../assets/Domestic/pondi.webp';
import himachal01Img from '../assets/Domestic/himachal 01.webp';
import rajasthanImg from '../assets/Domestic/rajasthan.webp';
import himachal02Img from '../assets/Domestic/himachal 02.webp';
import arunachalImg from '../assets/Domestic/arunachal.webp';
import himachalImg from '../assets/Domestic/himachal.webp';
import tamilnadu01Img from '../assets/Domestic/tamilnadu 01.webp';
import assamImg from '../assets/Domestic/assam.webp';
import jammuImg from '../assets/Domestic/jammu.webp';
import tamilnaduImg from '../assets/Domestic/tamilnadu.webp';
import bengalImg from '../assets/Domestic/bengal.webp';
import keralaImg from '../assets/Domestic/kerala.webp';
import telanganaImg from '../assets/Domestic/telangana.webp';
import delhiImg from '../assets/Domestic/delhi.webp';
import nagalandImg from '../assets/Domestic/nagaland.webp';
import uttarakhandImg from '../assets/Domestic/uttarakhand.webp';
import { useFormContext } from './FormContext';
import { Helmet } from "react-helmet";

function ContactPlace ({ formData, updateFormData }){
  const handleCheckboxChange = (e) => {
    const { name, id, checked } = e.target;

    if (checked) {
      updateFormData(name, formData.travel_where ? `${formData.travel_where},${id}` : id);
    } else {
      const updatedTravelWhere = formData.travel_where
        .split(',')
        .filter((title) => title !== id)
        .join(',');

      updateFormData(name, updatedTravelWhere);
    }
  };

  const { progress, updateProgress } = useFormContext();

  useEffect(() => {
    const progressInterval = setInterval(() => {
      updateProgress((prevProgress) => Math.min(prevProgress + 10, 100));
    }, 1000);

    return () => clearInterval(progressInterval);
  }, [updateProgress]);

  const loaderLineStyle = {
    width: `50%`,
    height: '4px',
    position: 'absolute',
    top: '6.8vh',
    left: '0',
    backgroundColor: '#12765e',
    zIndex: '1',
    transition: 'width 500ms ease-out',
  };
  const domesticData = [
    {
      id: 1,
      img: goaImg,
      video: "/assets/video/banner_tour.mp4",
      badge: "offer",
      price: 320,
      discount: 210,
      title: "Goa",
      desc: "Lorem ipsum dolor sit amet, consectetur est.",
      offers: "5 days | 6 nights",
      person: "2 person",
    },
    {
      id: 2,
      img: pondiImg,
      video: "/assets/video/banner_tour.mp4",
      badge: "offer",
      price: 320,
      discount: 210,
      title: "Pondicherry",
      desc: "Lorem ipsum dolor sit amet, consectetur est.",
      offers: "5 days | 6 nights",
      person: "2 person",
    },
    {
      id: 3,
      img: himachal01Img,
      video: "/assets/video/banner_tour.mp4",
      badge: "offer",
      price: 320,
      discount: 210,
      title: "Himachal",
      desc: "Lorem ipsum dolor sit amet, consectetur est.",
      offers: "5 days | 6 nights",
      person: "2 person",
    },
    {
      id: 4,
      img: rajasthanImg,
      video: "/assets/video/banner_tour.mp4",
      badge: "offer",
      price: 320,
      discount: 210,
      title: "Rajasthan",
      desc: "Lorem ipsum dolor sit amet, consectetur est.",
      offers: "5 days | 6 nights",
      person: "2 person",
    },
    {
      id: 5,
      img: himachal02Img,
      video: "/assets/video/banner_tour.mp4",
      badge: "offer",
      price: 320,
      discount: 210,
      title: "Himachal",
      desc: "Lorem ipsum dolor sit amet, consectetur est.",
      offers: "5 days | 6 nights",
      person: "2 person",
    },
    {
      id: 6,
      img: arunachalImg,
      video: "/assets/video/banner_tour.mp4",
      badge: "offer",
      price: 320,
      discount: 210,
      title: "Arunachal",
      desc: "Lorem ipsum dolor sit amet, consectetur est.",
      offers: "5 days | 6 nights",
      person: "2 person",
    },
    {
      id: 7,
      img: himachalImg,
      video: "/assets/video/banner_tour.mp4",
      badge: "offer",
      price: 320,
      discount: 210,
      title: "Himachal",
      desc: "Lorem ipsum dolor sit amet, consectetur est.",
      offers: "5 days | 6 nights",
      person: "2 person",
    },
    {
      id: 8,
      img: tamilnadu01Img,
      video: "/assets/video/banner_tour.mp4",
      badge: "offer",
      price: 320,
      discount: 210,
      title: "Tamilnadu",
      desc: "Lorem ipsum dolor sit amet, consectetur est.",
      offers: "5 days | 6 nights",
      person: "2 person",
    },
    {
      id: 9,
      img: assamImg,
      video: "/assets/video/banner_tour.mp4",
      badge: "offer",
      price: 320,
      discount: 210,
      title: "Assam",
      desc: "Lorem ipsum dolor sit amet, consectetur est.",
      offers: "5 days | 6 nights",
      person: "2 person",
    },
    {
      id: 10,
      img: jammuImg,
      video: "/assets/video/banner_tour.mp4",
      badge: "offer",
      price: 320,
      discount: 210,
      title: "Jammu",
      desc: "Lorem ipsum dolor sit amet, consectetur est.",
      offers: "5 days | 6 nights",
      person: "2 person",
    },
    {
      id: 11,
      img: tamilnaduImg,
      video: "/assets/video/banner_tour.mp4",
      badge: "offer",
      price: 320,
      discount: 210,
      title: "Tamil Nadu",
      desc: "Lorem ipsum dolor sit amet, consectetur est.",
      offers: "5 days | 6 nights",
      person: "2 person",
    },
    {
      id: 12,
      img: bengalImg,
      video: "/assets/video/banner_tour.mp4",
      badge: "offer",
      price: 320,
      discount: 210,
      title: "Bengal",
      desc: "Lorem ipsum dolor sit amet, consectetur est.",
      offers: "5 days | 6 nights",
      person: "2 person",
    },
    {
      id: 13,
      img: keralaImg,
      video: "/assets/video/banner_tour.mp4",
      badge: "offer",
      price: 320,
      discount: 210,
      title: "Kerala",
      desc: "Lorem ipsum dolor sit amet, consectetur est.",
      offers: "5 days | 6 nights",
      person: "2 person",
    },
    {
      id: 14,
      img: telanganaImg,
      video: "/assets/video/banner_tour.mp4",
      badge: "offer",
      price: 320,
      discount: 210,
      title: "Telangana",
      desc: "Lorem ipsum dolor sit amet, consectetur est.",
      offers: "5 days | 6 nights",
      person: "2 person",
    },
    {
      id: 15,
      img: delhiImg,
      video: "/assets/video/banner_tour.mp4",
      badge: "offer",
      price: 320,
      discount: 210,
      title: "Delhi",
      desc: "Lorem ipsum dolor sit amet, consectetur est.",
      offers: "5 days | 6 nights",
      person: "2 person",
    },
    {
      id: 16,
      img: nagalandImg,
      video: "/assets/video/banner_tour.mp4",
      badge: "offer",
      price: 320,
      discount: 210,
      title: "Nagaland",
      desc: "Lorem ipsum dolor sit amet, consectetur est.",
      offers: "5 days | 6 nights",
      person: "2 person",
    },
    {
      id: 17,
      img: uttarakhandImg,
      video: "/assets/video/banner_tour.mp4",
      badge: "offer",
      price: 320,
      discount: 210,
      title: "Uttarakhand",
      desc: "Lorem ipsum dolor sit amet, consectetur est.",
      offers: "5 days | 6 nights",
      person: "2 person",
    },
  ];
  
   
    return(
        <div style={{overflowX:"hidden"}}>
            <Header dark={true} />
            <Helmet>
                <meta name="robots" content="noindex, nofollow"/>
            </Helmet>
            <div style={{width:"100%", height:"4px", position:"relative"}}>
                <div style={{height:"100%", position:"absolute", top:"6.8vh", left:"0", backgroundColor:"rgb(237, 239, 240)", width:"100%"}}></div>
                <div style={loaderLineStyle}></div>
            </div>
            <div style={{margin:"10vh 7% 0 7%", maxWidth:"100%", display:"flex", flexDirection:"column",flexWrap:"wrap", justifyContent:"center", alignItems:"center"}}>
                {/* <div style={{display:"flex", justifyContent:"center", alignContent:"center", minWidth:"350px",maxWidth:"80%",}}>
                    <img src={spain2Img} style={{textAlign:"center", borderRadius:"25px", maxHeight:"25vh", width:"100%"}}/>
                    <div style={{position:"absolute", top:"15%", fontFamily:"PlayFair Display", fontSize:"40px", textDecoration:"bolder", color:"white", zIndex:"2"}}>
                        Ready to Explore
                    </div>
                    <div style={{position: "absolute",minWidth:"350px",maxWidth:"80%", height:"25vh",zIndex: "1",backgroundColor: "rgba(0, 0, 0, 0.3)",borderRadius: "20px"}}></div>
                    <svg style={{zIndex:"3", position: "absolute",top:"25%"}} width="168" height="62" viewBox="0 0 168 62" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.8105 24.98L60.2084 27.542L96.7175 52.522" stroke="#F7F7F7" stroke-width="1.92153"></path><path d="M96 53L132 32" stroke="white" stroke-width="1.92153" stroke-dasharray="2.56 2.56"></path><g filter="url(#filter0_d_793_23303)"><mask id="path-3-inside-1_793_23303" fill="white"><path fill-rule="evenodd" clip-rule="evenodd" d="M134.65 8.9764C133.788 8.74767 132.886 8.6333 131.945 8.6333C129.234 8.6333 126.848 9.58339 124.788 11.4836C122.727 13.3838 121.697 15.9351 121.697 19.1377C121.697 21.2727 122.546 23.5946 124.243 26.1032C125.941 28.6119 128.508 31.3287 131.945 34.2537C135.383 31.3287 137.95 28.6119 139.648 26.1032C140.793 24.4101 141.552 22.802 141.925 21.279C137.569 20.0979 134.365 16.1167 134.365 11.3871C134.365 10.5568 134.464 9.7495 134.65 8.9764Z"></path></mask><path fill-rule="evenodd" clip-rule="evenodd" d="M134.65 8.9764C133.788 8.74767 132.886 8.6333 131.945 8.6333C129.234 8.6333 126.848 9.58339 124.788 11.4836C122.727 13.3838 121.697 15.9351 121.697 19.1377C121.697 21.2727 122.546 23.5946 124.243 26.1032C125.941 28.6119 128.508 31.3287 131.945 34.2537C135.383 31.3287 137.95 28.6119 139.648 26.1032C140.793 24.4101 141.552 22.802 141.925 21.279C137.569 20.0979 134.365 16.1167 134.365 11.3871C134.365 10.5568 134.464 9.7495 134.65 8.9764Z" fill="#50C871"></path><path d="M134.65 8.9764L136.086 9.3225L136.424 7.91919L135.029 7.54911L134.65 8.9764ZM124.788 11.4836L123.787 10.3981L123.787 10.3981L124.788 11.4836ZM124.243 26.1032L123.02 26.9307L123.02 26.9307L124.243 26.1032ZM131.945 34.2537L130.988 35.3783L131.945 36.1926L132.902 35.3783L131.945 34.2537ZM139.648 26.1032L140.871 26.9307L140.871 26.9307L139.648 26.1032ZM141.925 21.279L143.359 21.6297L143.701 20.2307L142.311 19.8538L141.925 21.279ZM135.029 7.54911C134.036 7.28588 133.007 7.15665 131.945 7.15665V10.1099C132.765 10.1099 133.539 10.2095 134.272 10.4037L135.029 7.54911ZM131.945 7.15665C128.849 7.15665 126.11 8.25574 123.787 10.3981L125.789 12.5691C127.587 10.911 129.618 10.1099 131.945 10.1099V7.15665ZM123.787 10.3981C121.379 12.6189 120.221 15.5875 120.221 19.1377H123.174C123.174 16.2827 124.076 14.1486 125.789 12.5691L123.787 10.3981ZM120.221 19.1377C120.221 21.6674 121.224 24.2759 123.02 26.9307L125.466 25.2758C123.868 22.9132 123.174 20.8781 123.174 19.1377H120.221ZM123.02 26.9307C124.819 29.5898 127.494 32.4047 130.988 35.3783L132.902 33.1291C129.522 30.2528 127.062 27.634 125.466 25.2758L123.02 26.9307ZM132.902 35.3783C136.397 32.4047 139.071 29.5898 140.871 26.9307L138.425 25.2758C136.829 27.634 134.369 30.2528 130.988 33.1291L132.902 35.3783ZM140.871 26.9307C142.086 25.1342 142.934 23.3658 143.359 21.6297L140.49 20.9283C140.17 22.2381 139.5 23.6859 138.425 25.2758L140.871 26.9307ZM142.311 19.8538C138.582 18.8428 135.842 15.4331 135.842 11.3871H132.888C132.888 16.8002 136.555 21.3531 141.538 22.7042L142.311 19.8538ZM135.842 11.3871C135.842 10.6742 135.926 9.98312 136.086 9.3225L133.215 8.6303C133.001 9.51588 132.888 10.4393 132.888 11.3871H135.842Z" fill="white" mask="url(#path-3-inside-1_793_23303)"></path></g><mask id="mask0_793_23303" maskUnits="userSpaceOnUse" x="133" y="0" width="23" height="23" style={{maskType: "alpha"}}><rect x="133.227" width="22.7737" height="22.7737" fill="#D9D9D9"></rect></mask><g mask="url(#mask0_793_23303)"><path d="M143.665 16.1315H145.563V12.3359H149.359V10.4381H145.563V6.64248H143.665V10.4381H139.87V12.3359H143.665V16.1315ZM144.614 20.8761C143.301 20.8761 142.068 20.627 140.913 20.1288C139.759 19.6306 138.755 18.9545 137.901 18.1005C137.047 17.2465 136.37 16.2422 135.872 15.0877C135.374 13.9332 135.125 12.6997 135.125 11.387C135.125 10.0743 135.374 8.84077 135.872 7.68627C136.37 6.53177 137.047 5.52751 137.901 4.6735C138.755 3.81948 139.759 3.14339 140.913 2.64521C142.068 2.14704 143.301 1.89795 144.614 1.89795C145.927 1.89795 147.16 2.14704 148.315 2.64521C149.469 3.14339 150.474 3.81948 151.328 4.6735C152.182 5.52751 152.858 6.53177 153.356 7.68627C153.854 8.84077 154.103 10.0743 154.103 11.387C154.103 12.6997 153.854 13.9332 153.356 15.0877C152.858 16.2422 152.182 17.2465 151.328 18.1005C150.474 18.9545 149.469 19.6306 148.315 20.1288C147.16 20.627 145.927 20.8761 144.614 20.8761Z" fill="white"></path></g><rect x="4.93402" y="16.4633" width="20.8764" height="20.8764" rx="10.4382" fill="white"></rect><path d="M16.832 28.8553H13.872L13.322 30.2153H11.302L14.392 23.2153H16.342L19.442 30.2153H17.382L16.832 28.8553ZM16.252 27.3953L15.352 25.1553L14.452 27.3953H16.252Z" fill="#3F4144"></path><rect x="4.93402" y="16.4633" width="20.8764" height="20.8764" rx="10.4382" stroke="#3F4144" stroke-width="0.38"></rect><rect x="53.9949" y="19.4075" width="20.112" height="20.112" rx="10.056" fill="white"></rect><path d="M66.2886 29.1273C66.6886 29.2673 67.0019 29.4873 67.2286 29.7873C67.4553 30.0807 67.5686 30.4373 67.5686 30.8573C67.5686 31.4707 67.3219 31.944 66.8286 32.2773C66.3353 32.6107 65.6219 32.7773 64.6886 32.7773H60.9086V25.7773H64.4886C65.3819 25.7773 66.0619 25.944 66.5286 26.2773C66.9953 26.604 67.2286 27.0473 67.2286 27.6073C67.2286 27.9407 67.1453 28.2407 66.9786 28.5073C66.8186 28.7673 66.5886 28.974 66.2886 29.1273ZM62.8686 27.2073V28.5573H64.2286C64.8953 28.5573 65.2286 28.3307 65.2286 27.8773C65.2286 27.4307 64.8953 27.2073 64.2286 27.2073H62.8686ZM64.5286 31.3473C65.2219 31.3473 65.5686 31.1107 65.5686 30.6373C65.5686 30.164 65.2219 29.9273 64.5286 29.9273H62.8686V31.3473H64.5286Z" fill="#3F4144"></path><rect x="53.9949" y="19.4075" width="20.112" height="20.112" rx="10.056" stroke="#3F4144" stroke-width="0.384307"></rect><rect x="89.864" y="41.1848" width="20.112" height="20.112" rx="10.056" fill="white"></rect><path d="M100.419 54.6947C99.6858 54.6947 99.0258 54.5414 98.4391 54.2347C97.8591 53.9214 97.4024 53.488 97.0691 52.9347C96.7358 52.3814 96.5691 51.7547 96.5691 51.0547C96.5691 50.3547 96.7358 49.728 97.0691 49.1747C97.4024 48.6214 97.8591 48.1914 98.4391 47.8847C99.0258 47.5714 99.6858 47.4147 100.419 47.4147C101.059 47.4147 101.636 47.528 102.149 47.7547C102.662 47.9814 103.089 48.308 103.429 48.7347L102.169 49.8747C101.716 49.328 101.166 49.0547 100.519 49.0547C100.139 49.0547 99.7991 49.138 99.4991 49.3047C99.2058 49.4714 98.9758 49.708 98.8091 50.0147C98.6491 50.3147 98.5691 50.6614 98.5691 51.0547C98.5691 51.448 98.6491 51.798 98.8091 52.1047C98.9758 52.4047 99.2058 52.638 99.4991 52.8047C99.7991 52.9714 100.139 53.0547 100.519 53.0547C101.166 53.0547 101.716 52.7814 102.169 52.2347L103.429 53.3747C103.089 53.8014 102.662 54.128 102.149 54.3547C101.636 54.5814 101.059 54.6947 100.419 54.6947Z" fill="#3F4144"></path><rect x="89.864" y="41.1848" width="20.112" height="20.112" rx="10.056" stroke="#3F4144" stroke-width="0.384307"></rect><defs><filter id="filter0_d_793_23303" x="115.791" y="4.20336" width="32.0407" height="37.4338" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1.47665"></feOffset><feGaussianBlur stdDeviation="2.95329"></feGaussianBlur><feColorMatrix type="matrix" values="0 0 0 0 0.247059 0 0 0 0 0.254902 0 0 0 0 0.266667 0 0 0 0.3 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_793_23303"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_793_23303" result="shape"></feBlend></filter></defs></svg>
                </div> */}
                <div style={{marginTop:"5%"}}>
                    <div style={{fontWeight:"600", fontSize:"18px", alignItems:"left"}}>What would you like to see? </div>
                </div>
                <div style={{marginTop:"5%", display:"flex", flexWrap:"wrap", justifyContent:"center"}}>
                <section style={{paddingBottom:"100px"}}>
                    {domesticData.map((sport) => (
                        <div class="tile">
                            <div class="tile-ctr">
                            <input type="checkbox" name="travel_where" id={sport.title} checked={formData.travel_where.includes(sport.title)} onChange={handleCheckboxChange}/>
                            <label for={`${sport.title}`}>
                                <img src={sport.img} alt="" />
                            </label>
                            <div style={{position:"relative", textAlign:"center", top:"60%"}}>
                                {sport.title}
                            </div>
                            </div>
                        </div>
                     ))}
                    {/* <div class="tile">
                        <div class="tile-ctr">
                        <input type="checkbox" name="sports" id="sport2" />
                        <label for="sport2">
                            <img src="https://i.pinimg.com/564x/70/eb/a1/70eba1527ae833c401334ede872915ac.jpg" alt="" />
                        </label>
                        </div>
                    </div>

                    <div class="tile">
                        <div class="tile-ctr">
                        <input type="checkbox" name="sports" id="sport3" />
                        <label for="sport3">
                            <img src="https://i.pinimg.com/564x/8f/a5/03/8fa503a63da1eb5ef87531979f3154f7.jpg" alt="" />
                        </label>
                        </div>
                    </div> */}
                    </section>
                </div>
            </div>
            <div style={{position:"fixed",top:"91%", width:"100%",height:"9vh", backgroundColor:"white", zIndex:"2"}}>
                <a href="/contact/price" style={{color:"white", textDecoration:"none", fontFamily:"Montserrat"}}>
                    <div style={{position:"fixed",top:"93%", width:"90%", background:"#12765e", height:"5vh", margin:"0 5%", display:"flex", justifyContent:"center", alignContent:"center", alignItems:"center", color:"white", fontSize:"17px", letterSpacing:"4px", boxShadow:"0 0 8px rgba(117, 117, 117, 0.5)", borderRadius:"3px"}}>
                        NEXT
                    </div>
                </a>
            </div>
        </div>
    )
}

export default ContactPlace